import { ApiRequest } from '../baseService'

// Host "AI Feature" page: each AI feature's on/off switch and options, per tenant.
const BaseRoute = 'app/ai-feature-settings'

function Get(tenantId: string) {
  return ApiRequest.get(`${BaseRoute}/${tenantId}`)
}

// Saves one section of the page — only the fields sent are written.
function Update(tenantId: string, payload) {
  return ApiRequest.put(`${BaseRoute}/${tenantId}`, payload)
}

export interface AssistantFeedbackQuery {
  /** 1 = good, -1 = bad; left out, both. */
  rating?: number
  reason?: string
  audience?: string
  /** UTC instants: rated at or after `from`, before `to`. */
  from?: string
  to?: string
  skipCount: number
  maxResultCount: number
}

// Host "Assistant Feedback" page: the ratings one tenant's users gave the Assistant's answers.
// Rating, reason, the user's note and what the turn ran on - never the question or the answer.
function GetAssistantFeedback(
  tenantId: string,
  params: AssistantFeedbackQuery
) {
  return ApiRequest.get(`app/assistant-feedback/${tenantId}`, { params })
}

// The system-wide switch of the AI Assistant: one value for every tenant, host only.
function GetAssistantSwitch() {
  return ApiRequest.get(`${BaseRoute}/assistant-switch`)
}

function SetAssistantSwitch(enabled: boolean) {
  return ApiRequest.put(`${BaseRoute}/assistant-switch`, { enabled })
}

export interface AssistantAliasQuery {
  /** Only aliases that begin with this text. */
  filter?: string
  skipCount: number
  maxResultCount: number
}

// The aliases the AI Assistant learned for one tenant (a shorthand a user confirmed for a
// record), each with the record's current name. Host only.
function GetAssistantAliases(tenantId: string, params: AssistantAliasQuery) {
  return ApiRequest.get(`${BaseRoute}/${tenantId}/assistant-aliases`, {
    params,
  })
}

function DeleteAssistantAlias(tenantId: string, aliasId: string) {
  return ApiRequest.delete(
    `${BaseRoute}/${tenantId}/assistant-aliases/${aliasId}`
  )
}

const API = {
  Get,
  Update,
  GetAssistantFeedback,
  GetAssistantSwitch,
  SetAssistantSwitch,
  GetAssistantAliases,
  DeleteAssistantAlias,
}

export default API
